export default "__VITE_ASSET__CE4xY6qh__"